import i18n from '../../utils/i18n';

export const SELECT_TABLE_COLUMNS = [
	{
		key: 'rank',
		numeric: false,
		sortable: true,
		label: i18n.t('components.selectTable.columns.rank'),
		unit: ''
	},
	{
		key: 'selectButton',
		numeric: false,
		sortable: false,
		label: i18n.t('components.selectTable.columns.design'),
		unit: ''
	},
	{
		key: 'schematic',
		numeric: false,
		sortable: false,
		label: i18n.t('components.selectTable.columns.schematic'),
		unit: ''
	},
	{
		key: 'topology',
		numeric: true,
		sortable: true,
		label: i18n.t('components.selectTable.columns.topology'),
		unit: ''
	},
	{
		key: 'autoQualified',
		numeric: false,
		sortable: true,
		label: i18n.t('components.selectTable.columns.autoQualified'),
		unit: ''
	},
	{
		key: 'efficiency',
		numeric: true,
		sortable: true,
		label: i18n.t('components.selectTable.columns.efficiency'),
		unit: '[%]'
	},
	{
		key: 'icTemperature',
		numeric: true,
		sortable: true,
		label: i18n.t('components.selectTable.columns.icTemperature'),
		unit: '[\u00B0C]'
	},
	{
		key: 'designPriceFormatted',
		numeric: true,
		sortable: true,
		label: i18n.t('components.selectTable.columns.designPrice'),
		unit: '[$]'
	},
	{
		key: 'bomCount',
		numeric: true,
		sortable: true,
		label: i18n.t('components.selectTable.columns.bomCount'),
		unit: ''
	},
	{
		key: 'designFootprint',
		numeric: true,
		sortable: true,
		label: i18n.t('components.selectTable.columns.designFootprint'),
		unit: '[mm\u00b2]'
	},
	{
		key: 'quiescentCurrent',
		numeric: true,
		sortable: true,
		label: i18n.t('components.selectTable.columns.quiescentCurrent'),
		unit: '[mA]'
	},
	{
		key: 'switchingFrequency',
		numeric: true,
		sortable: true,
		label: i18n.t('components.selectTable.columns.switchingFrequency'),
		unit: '[kHz]'
	}
];

export const OPT_SELECT_TABLE_COLUMNS = [
	/* Select all opt. columns checkbox */
	{
		key: 'all',
		label: i18n.t('components.selectTable.optColumns.all'),
		unit: ''
	},
	{
		key: 'icPackage',
		numeric: false,
		sortable: true,
		label: i18n.t('components.selectTable.optColumns.icPackage'),
		unit: ''
	},
	{
		key: 'icPrice',
		numeric: true,
		sortable: true,
		label: i18n.t('components.selectTable.optColumns.icPrice'),
		unit: '[$]'
	},
	{
		key: 'icCurrentLimit',
		numeric: true,
		sortable: true,
		label: i18n.t('components.selectTable.optColumns.icCurrLimit'),
		unit: '[A]'
	},
	{
		key: 'vinMin',
		numeric: true,
		sortable: true,
		label: 'Vin min',
		unit: '[V]'
	},
	{
		key: 'vinMax',
		numeric: true,
		sortable: true,
		label: 'Vin max',
		unit: '[V]'
	},
	{
		key: 'vout',
		numeric: false,
		sortable: true,
		label: 'Vout',
		unit: '[V]'
	},
	{
		key: 'ioutMax',
		numeric: true,
		sortable: true,
		label: 'Iout Max',
		unit: '[A]'
	},
	{
		key: 'enable',
		numeric: false,
		sortable: false,
		label: i18n.t('components.selectTable.optColumns.enable'),
		unit: ''
	},
	{
		key: 'adjustableSwitchingFrequency',
		numeric: false,
		sortable: false,
		label: i18n.t('components.selectTable.optColumns.adjustFrequency'),
		unit: ''
	},
	{
		key: 'lightLoadEffEnhance',
		numeric: false,
		sortable: false,
		label: i18n.t('components.selectTable.optColumns.lightLoad'),
		unit: ''
	},
	{
		key: 'adjustableSoftStart',
		numeric: false,
		sortable: false,
		label: i18n.t('components.selectTable.optColumns.softStart'),
		unit: ''
	},
	{
		key: 'powerGood',
		numeric: false,
		sortable: false,
		label: i18n.t('components.selectTable.optColumns.powerGood'),
		unit: ''
	},
	{
		key: 'pmBus',
		numeric: false,
		sortable: false,
		label: 'PMBus/I\u00b2C',
		unit: ''
	},
	{
		key: 'digitalVout',
		numeric: false,
		sortable: false,
		label: i18n.t('components.selectTable.optColumns.digitalVout'),
		unit: ''
	},
	{
		key: 'psrr',
		numeric: true,
		sortable: true,
		label: 'PSRR',
		unit: '[dB]'
	},
	{
		key: 'dropoutVoltage',
		numeric: true,
		sortable: true,
		label: i18n.t('components.selectTable.optColumns.dropoutVoltage'),
		unit: '[V]'
	}
];
